import { BrnTextarea } from './lib/brn-textarea';

export * from './lib/brn-textarea';

export const BrnTextareaImports = [BrnTextarea] as const;
